export default __webpack_public_path__ + "static/media/Wordpress_ButtaBoxx_plant-powered_premium_skincare_beauty_treats_delivered_to_your_door.adfb2edd.png";